<template>
    <div v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.7)">
        <el-row style="height: 40px;line-height: 40px;margin-top: 20px">
            <el-col :span="14">
                <span>月份</span>
<!--                <el-date-picker-->
<!--                        v-model="date"-->
<!--                        style="width: 150px"-->
<!--                        format="yyyy年MM月"-->
<!--                        value-format="yyyy-MM"-->
<!--                        type="month"-->
<!--                        placeholder="选择月">-->
<!--                </el-date-picker>-->
                <reportMonth :handleSelectInput="handleSelectInput"></reportMonth>
            </el-col>
            <el-col :span="10" v-if="isManager">
                <div style="float: right">
                    <span style="font-size: 16px;font-weight: bold;margin-right: 10px;">辖区</span>
                    <popedom :handleSelectInput="handleSelectInputClick" :shelfData="shelfData"></popedom>
                </div>
            </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
            <el-col>
                <el-button style="background: #4EC880;border:none;color: #fff" size="small" @click.stop="searchWeekList">查询</el-button>
                <el-button style="background: #D0021B;border:none;color: #fff" size="small" @click.stop="ResetClick">重置</el-button>
                <el-button  size="small" icon="el-icon-upload2" @click.stop="exportDataClick" style="float: right;background: #4A90E2;border:none;color: #fff">导出数据</el-button>
                <el-button size="small" style="float: right;background: #FF9901;border:none;color: #fff" icon="el-icon-upload2" @click.stop="exportDetailClick">
                    导出明细
                </el-button>
            </el-col>
            <el-col style="border-bottom: 2px dotted rgb(231, 234, 236);margin-top: 20px"></el-col>
        </el-row>
        <div>
            <div style="margin-top: 15px;" id="title">
                <span style="font-weight: bold;font-size: 18px">{{yearsDate}}</span>
                <span style="color:#6fa7e8;margin-left: 10px">辖区门店{{storeNum}}家</span>
                <el-divider direction="vertical" style="background: #6fa7e8"></el-divider>
                <span style="color:#6fa7e8">目标客户数{{accountsNum}}家</span>
            </div>
            <div style="display: flex;justify-content: flex-start">
                <el-col span="10" style="">
                    <el-col span="17" id="tar" style="height: 150px"></el-col>
                    <el-col span="6" id="coverEchart" style="height: 150px;display: inline-block"></el-col>
                    <el-col style="color: #4A90E2;text-align: center;margin-top: 20px">目标客户覆盖</el-col>
                </el-col>
                <div style="height: 100px;width: 2px;background: #9fa5ac;margin: 20px 120px 50px 100px"></div>
                <el-col span="6">
                    <el-col style="height: 180px" id="line"></el-col>
                    <el-col style="color: #4A90E2;text-align: center;margin-top: 20px">目标客户拜访</el-col>
                </el-col>
            </div>
        </div>
        <el-table
                :data="storeTableArray"
                style="width: 100%;margin-top: 20px"
                v-show="!isManager||(isManager&&territory_type==='ENDPOINT')"
        >
            <el-table-column
                    type="index"
                    label="序号"
                    sortable>
            </el-table-column>
            <el-table-column
                    prop="account_name"
                    label="门店名称"
                    sortable>
            </el-table-column>
            <el-table-column
                    prop="segment_id"
                    label="客户等级 " sortable>
            </el-table-column>
            <el-table-column
                    prop="calls"
                    label="拜访次数" sortable>
            </el-table-column>
            <el-table-column
                    prop="call_achieved"
                    label="是否正确覆盖" sortable>
            </el-table-column>
        </el-table>
        <el-table
                :data="storeTableArray"
                style="width: 100%;margin-top: 20px"
                v-show="isManager&&territory_type==='CONTAINER'"
        >
            <el-table-column
                    type="index"
                    label="序号"
                    sortable>
            </el-table-column>
            <el-table-column
                    prop="territory_name"
                    label="下级辖区"
                    sortable>
                <template slot-scope="scope">
                    {{scope.row.territory_name}}{{scope.row.staff_name?'('+scope.row.staff_name+')':''}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="clients"
                    label="辖区门店数" sortable
                    width="115">
            </el-table-column>
            <el-table-column
                    prop="accounts"
                    label="目标客户数" sortable
                    width="115">
            </el-table-column>
            <el-table-column
                    prop="calls"
                    label="目标客户拜访次数" sortable>
            </el-table-column>
            <el-table-column
                    prop="call_accounts"
                    label="已拜访目标客户数" sortable>
            </el-table-column>
            <el-table-column
                    prop="not_call_accounts"
                    label="未拜访目标客户数" sortable>
            </el-table-column>
            <el-table-column
                    prop="visit_coverage"
                    label="拜访覆盖率" sortable
                    width="115">
            </el-table-column>
            <el-table-column
                    prop="correct_visit_coverage"
                    label="正确拜访覆盖率" sortable>
            </el-table-column>
        </el-table>

    </div>
</template>

<script>
    import popedom from "../../popedom";
    import moment from "moment";
    import http from "../../../../../APIService/http";
    import reportMonth from '../../reportMonth'
    export default {
        name: "medicalChannel",
        data(){
            return{
                array:[],
                tar:'',
                coverEchart:'',
                line:'',
                departments:'',
                date:'',
                isManager:this.$store.getters.getUser.role !== 'staff',
                yearsDate:'',
                storeNum:0,
                targetCustomer:0,
                aNum:0,
                bNum:0,
                cNum:0,
                dNum:0,
                accountsNum:0,
                call_accountsNum:0,
                visit_A:0,
                visit_frequency_A:0,
                visit_B:0,
                visit_frequency_B:0,
                visit_C:0,
                visit_frequency_C:0,
                visit_D:0,
                visit_frequency_D:0,
                storeTableArray:[],
                clienteleNum:0,
                loading:false,
                gradeList:[],
                actual_call_frequency:[],
                target_call_frequency:[],
                eachLevel:[],
                territory_type:this.$store.getters.getUser.role=='staff'?'ENDPOINT':'CONTAINER'

            }
        },
        components:{
            popedom,
            reportMonth
        },
        created() {

        },
        mounted() {
            window.onresize = () => {
                this.tar.resize()
                this.coverEchart.resize()
                this.line.resize()
            }
            this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')
            if(!this.isManager){
                this.getVisitCoverStaffTerritory()
                // this.getData()
            }
            this.getData()
            this.getTableData()

        },
        methods:{
            shelfData(){
                this.getData()
                this.getTableData()
            },
            handleSelectInputClick(){
                this.getData()
                this.getTableData()
            },
            handleSelectInput(j){
                this.date = j
            },
            async getVisitCoverStaffTerritory(){
                try {
                        let user = this.$store.getters.getUser
                        let data = {
                            tenant_id:user.tenant_id,
                            user_id : user.user_id,
                            month : this.GLOBAL.date,
                        }
                        http.post('/wapi/v1/getVisitCoverStaffTerritory',data).then(res=>{
                            if(res.success){
                                this.GLOBAL.territory_id = res.data

                            }
                        })
                }  catch (e) {

                }
            },
            async getData(){
                // let loading = this.$loading({
                //     lock: true,
                //     text: '拼命加载中',
                //     spinner: 'el-icon-loading',
                //     background: 'rgba(0, 0, 0, 0.7)'
                // });
                // this.loading = true
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        role : user.role,
                        month : this.GLOBAL.date,
                        territory_id : this.GLOBAL.territory_id,
                        reference_obj:'RETAILSTORE'
                    }
                    await http.post('/wapi/v1/getVisitCover_r',data).then(res=>{
                        if(res.success){
                            this.gradeList = []
                            this.actual_call_frequency = []
                            this.target_call_frequency = []
                            this.accountsNum = 0
                            this.call_accountsNum = 0
                            this.eachLevel = []
                            const array = res.data.array
                            array.forEach(item=>{
                                this.eachLevel.unshift([Number(item.accounts),item.segment_id])
                                this.gradeList.push(item.segment_id)
                                this.actual_call_frequency.push(Number(item.call_frequency_avg))
                                this.target_call_frequency.push(Number(item.call_frequency_target))
                                this.accountsNum += Number(item.accounts)
                                this.call_accountsNum += Number(item.call_accounts)
                            })
                        // console.log(res.data)
                        //     this.storeNum=res.data.retailstoreArray.length
                        //     this.targetCustomer=res.data.accountArray.length
                        //     this.aNum = 0
                        //     this.bNum = 0
                        //     this.cNum = 0
                        //     this.dNum = 0
                        //     for(let i = 0; i<res.data.levelArray.length;i++){
                        //         if(res.data.levelArray[i].segment_id == 'A'){
                        //             this.aNum += 1
                        //         }else if(res.data.levelArray[i].segment_id == 'B'){
                        //             this.bNum += 1
                        //         }else if(res.data.levelArray[i].segment_id == 'C'){
                        //             this.cNum += 1
                        //         }else{
                        //             this.dNum += 1
                        //         }
                        //     }
                        //     this.visit_A = 0
                        //     this.visit_frequency_A = 0
                        //     this.visit_B = 0
                        //     this.visit_frequency_B = 0
                        //     this.visit_C = 0
                        //     this.visit_frequency_C = 0
                        //     this.visit_D = 0
                        //     this.visit_frequency_D = 0
                        //     for(let j = 0; j<res.data.coverArray.length;j++){
                        //
                        //         if(res.data.coverArray[j].segment_id == 'A'){
                        //             this.visit_A += Number(res.data.coverArray[j].calls)
                        //             this.visit_frequency_A += Number(res.data.coverArray[j].call_frequency_avg)
                        //         }else if(res.data.coverArray[j].segment_id == 'B'){
                        //             this.visit_B += Number(res.data.coverArray[j].calls)
                        //             this.visit_frequency_B += Number(res.data.coverArray[j].call_frequency_avg)
                        //         }else if(res.data.coverArray[j].segment_id == 'C'){
                        //             this.visit_C += Number(res.data.coverArray[j].calls)
                        //             this.visit_frequency_C += Number(res.data.coverArray[j].call_frequency_avg)
                        //         }else{
                        //             this.visit_D += Number(res.data.coverArray[j].calls)
                        //             this.visit_frequency_D += Number(res.data.coverArray[j].call_frequency_avg)
                        //         }
                        //     }
                        //     this.storeTableArray = res.data.storeTableArray
                        //     this.clienteleNum = 0
                        //     this.accountsNum = 0
                        //     if(!this.isManager){
                        //         this.clienteleNum = this.accountNum
                        //         this.storeTableArray.forEach(item=>{
                        //             if(item.call_achieved == 'T'){
                        //                 item.call_achieved = '是'
                        //                 this.accountsNum += 1
                        //             }else if(item.call_achieved == 'F'){
                        //                 item.call_achieved = '否'
                        //             }
                        //         })
                        //     }else{
                        //         for(let i = 0;i<this.storeTableArray.length;i++){
                        //             this.clienteleNum += this.storeTableArray[i].accounts
                        //             this.accountsNum += this.storeTableArray[i].call_accounts
                        //         }
                        //     }

                            this.init()
                            // loading.close()
                            // this.loading = false
                        }

                    })
            }catch (e) {
                    // loading.close()
                    this.loading = false
                }
            },
            async getTableData(){
                this.loading = true
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        user_id : user.user_id,
                        tenant_id : user.tenant_id,
                        role : user.role,
                        month : this.GLOBAL.date,
                        territory_id : this.GLOBAL.territory_id,
                        reference_obj:'RETAILSTORE'
                    }
                    await http.post('/wapi/v1/getVisitCoverTableData',data).then(res=>{
                        if(res.success){
                            this.storeNum = 0
                            this.storeTableArray = res.data.list
                            this.territory_type = res.data.type
                            if(this.territory_type === 'ENDPOINT'){
                                this.storeNum = this.storeTableArray.length
                            }else{
                                this.storeTableArray.forEach(item=>{
                                    this.storeNum += Number(item.clients)
                                })
                            }
                            this.loading = false
                        }
                    })
                }  catch (e) {

                    this.loading = false
                }
            },
            init(){
                this.tar=this.$echarts.init(document.getElementById('tar'))
                this.tar.setOption({
                    color:['#419DE7'],
                    dataset: {
                        source: this.eachLevel
                    },
                    grid: {containLabel: false,top:20,bottom:0},
                    xAxis: {name: 'amount',show:false},
                    yAxis: {type: 'category',
                        axisLine:{
                            lineStyle:{
                                color:'#D8D8D8',
                                width:2,

                            }
                        },
                        nameTextStyle:{
                            color:'#909498'
                        }
                    },

                    series: [
                        {
                            type: 'bar',
                            barWidth: 20,
                            encode: {
                                x: 'amount',
                                y: 'product'
                            },
                            itemStyle: {
                                normal: {
                                    label: {
                                        show:true,
                                        position: 'right',
                                        textStyle: {
                                            color: '#333'
                                        },
                                        formatter:function(params) {
                                            if(params.value){
                                                return params.value[0]+'家'
                                            }else{
                                                return '';
                                            }
                                        }
                                    },
                                }
                            }
                        }
                    ]
                })
                this.coverEchart=this.$echarts.init(document.getElementById('coverEchart'))
                this.coverEchart.setOption({
                    color:['#419DE7', '#d9ebfa'],
                    title:{
                        text:'目标客户覆盖率',
                        textStyle: {
                            color:'#909399',
                            fontWeight: 100,
                            fontSize: 14
                        },
                        x:'center',
                        y:'bottom'
                    },
                    series: [
                        {
                            type: 'pie',
                            center: ['50%', '40%'],
                            radius: ['70%', '80%'],
                            avoidLabelOverlap: false,
                            hoverAnimation: false,
                            label: {
                                normal: {
                                    show: true,
                                    position: 'center',
                                    formatter: '{w|{d}}{z|%}\n {t|{c}家}',
                                    rich:{
                                        w:{
                                            fontSize:21,
                                            fontWeight:'bold'
                                        },
                                        z:{
                                            fontSize:14,
                                        },
                                        t:{
                                            color:'#909399'
                                        }
                                    }
                                }
                            },
                            labelLine: {
                                normal: {
                                    show: false
                                }
                            },
                            data:[{
                                value: this.accountsNum,
                            },
                                {
                                    value: this.accountsNum - this.call_accountsNum,
                                    label: {
                                        normal: {
                                            show: false
                                        }
                                    }
                                }
                            ]
                        }
                    ]
                })
                this.line=this.$echarts.init(document.getElementById('line'))
                this.line.setOption({
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'none',
                        }
                    },
                    tooltip:{
                        backgroundColor:'rgba(209,99,102,0.7)'
                    },
                    grid:{
                        top:10,
                        left:0,
                        // bottom:'30%',
                        right:0
                    },
                    legend: {
                        data: ['实际拜访频率', '目标拜访频率'],
                        bottom:0
                    },
                    xAxis: [
                        {
                            type: 'category',
                            data: this.gradeList,
                            axisPointer: {
                                type: 'none'
                            },
                            axisLine:{
                                lineStyle:{
                                    color:'#D8D8D8',
                                    width:2,
                                }
                            },
                        }
                    ],
                    yAxis: [
                        {
                            type: 'value',
                            name: '水量',
                            show:false,
                            min: function(value) {return value.min;},
                            max: function(value) {return value.max;},
                            axisLabel: {
                                formatter: '{value} ml'
                            }
                        },
                        {
                            type: 'value',
                            name: '温度',
                            show:false,
                            min: function(value) {return value.min;},
                            max: function(value) {return value.max;},
                            axisLabel: {
                                formatter: '{value} °C'
                            }
                        }
                    ],
                    series: [
                        {
                            name: '实际拜访频率',
                            type: 'bar',
                            yAxisIndex: 1,
                            data: this.actual_call_frequency,
                            barWidth:20,
                            itemStyle:{
                                normal:{
                                    color:'#ff9901'
                                }
                            }
                        },
                        {
                            name: '目标拜访频率',
                            type: 'line',
                            yAxisIndex: 1,
                            data: this.target_call_frequency,
                            itemStyle:{
                                normal:{
                                    color:'#d16366'
                                }
                            }
                        }
                    ]
                })
            },
            searchWeekList(){
                this.GLOBAL.date = this.date
                this.yearsDate = moment(this.GLOBAL.date).format('YYYY年M月')


                this.storeNum=0,
                this.targetCustomer=0,
                this.aNum=0,
                this.bNum=0,
                this.cNum=0,
                this.dNum=0,
                this.accountsNum=0,
                this.visit_A=0,
                this.visit_frequency_A=0,
                this.visit_B=0,
                this.visit_frequency_B=0,
                this.visit_C=0,
                this.visit_frequency_C=0,
                this.visit_D=0,
                this.visit_frequency_D=0,
                this.storeTableArray=[]
                this.getData()
                this.getTableData()
            },
            ResetClick(){
                this.date = ''
            },
            exportDataClick(){
                if(this.isManager){
                    this.exportClick()
                }else{
                    this.exportClickStaff()
                }
            },
            exportClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['下级辖区', '辖区门店数', '目标客户数', '目标客户拜访次数', '已拜访目标客户数','未拜访目标客户数','拜访覆盖率','正确拜访覆盖率']
                        const filterVal = [
                            'territory_name',
                            'clients',
                            'accounts',
                            'calls',
                            'call_accounts',
                            'not_call_accounts',
                            'visit_coverage',
                            'correct_visit_coverage',
                        ]
                        const list = JSON.parse(JSON.stringify(this.storeTableArray))
                        list.forEach(item=>{
                            let str = item.staff_name ? '('+item.staff_name+')':''
                            item.territory_name = item.territory_name + str
                        })
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '拜访覆盖分析(零售终端)',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            exportClickStaff(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = ['门店名称', '客户等级','拜访次数','是否正确覆盖']
                        const filterVal = [
                            'account_name',
                            'segment_id',
                            'calls',
                            'call_achieved',
                        ]

                        const list = this.storeTableArray
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '拜访覆盖分析(零售终端)',
                            autoWidth: this.autoWidth
                        })
                    })
                    loading.close();
                } catch (err) {
                    loading.close();
                    this.error()
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            exportDetailClick(){
                const loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try{
                    let data ={
                        user_id:this.$store.getters.getUser.user_id,
                        tenant_id:this.$store.getters.getUser.tenant_id,
                        role:this.$store.getters.getUser.role,
                        month:this.GLOBAL.date,
                        territory_id:this.GLOBAL.territory_id,
                    }
                    http.post('/wapi/v1/getSignDetailVisitRetail',data).then(res=>{
                        if(res.success){
                            this.array = res.data
                            this.exportClick1()
                            loading.close()
                        }
                    })
                }catch (e) {
                    loading.close()
                }

            },
            exportClick1(){

                try {
                    import('@/vendor/Export2Excel').then(excel => {
                        const tHeader = [ '拜访日期', '门店编码', '门店名称', '客户等级','创建人']
                        const filterVal = [
                            'activity_date',
                            'store_code',
                            'store_name',
                            'segment_id',
                            'last_name'
                        ]

                        const list = this.array
                        const data = this.formatJson(filterVal, list)

                        excel.export_json_to_excel({
                            header: tHeader,
                            data,
                            filename: '拜访覆盖分析明细（零售终端）',
                            autoWidth: this.autoWidth
                        })
                    })

                } catch (err) {

                    this.error()
                }
            },

        }
    }
</script>

<style scoped>
    #title >>> .el-divider--vertical{
        background: #6fa7e8!important;
        width: 2px!important;
        margin: -1px 5px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/statement/components/visitCover/components/retailOutlet.vue